@if (anmalanTradslag) {
  <div class="d-flex">
    @if (allatradslag?.length > 0) {
      <div>
        <rask-selector
          label="trädslag"
          [values]="allatradslag"
          [(ngModel)]="valttradslag"
          [disabled]="readonly"
          [exclude]="excludedTradslag()"
          placeholder="Välj trädslag"
          (change)="tradslagChanged($event)"
          [canDelete]="false"
          [viewFormatter]="viewFormatter">
        </rask-selector>
      </div>
    }
    <div>
      <rask-input-number [useDecimalProcessor]="true"
        label="antal hektar"
        [(ngModel)]="anmalanTradslag.arealHa"
        [disabled]="readonly"
        (change)="arealHaChanged($event)"
        [required]="true"
        [min]="0">
      </rask-input-number>
    </div>
    <div>
      <rask-input-number [useDecimalProcessor]="true"
        label="Antal träd (PL/ha)"
        [(ngModel)]="anmalanTradslag.antalPlantor"
        [disabled]="readonly"
        (change)="antalPlantorChanged($event)"
        [isDecimal]="false"
        [min]="0">
      </rask-input-number>
    </div>
    <div class="d-flex" >
      <div class="mt-auto tradslag-delete-width">
        @if (index !== 0) {
          <rask-icon-button [disabled]="readonly" (click)="delete()" icon="far fa-trash-alt" negative></rask-icon-button>
        }
      </div>
    </div>
  </div>
}